import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { LOCIZE_NAMESPACE } from 'main/common'
import { getAsset, IWhitelabelContext, useWhitelabel } from 'main/framework'
import { Text as BaseText } from 'main/ui'
import { AssetName } from 'main/util/asset'

import { Section } from '../../../components/school/common'
import { SchoolPage_school as School } from '../gql'
import { Container, PhoneLink, Title } from './NetworkContactDetails.styles'

// Fetch the contact details copy for this school, if it has any.
// First checks for an active WhitelabelContext and then falls back
// to the first of the school's assigned networks.
function getCopy(whitelabelContext: IWhitelabelContext, school: School) {
  const schoolNetwork = JSON.parse(school.networks[0]?.whitelabelOptions || '{}')

  const doGetAsset = whitelabelContext.isWhitelabeled
    ? whitelabelContext.getAsset
    : (a: string) => getAsset(schoolNetwork, a)

  return {
    title: doGetAsset(AssetName.NETWORK_CONTACT_DETAILS__SCHOOL_PAGE__TITLE),
    body: doGetAsset(AssetName.NETWORK_CONTACT_DETAILS__BODY),
    phone: doGetAsset(AssetName.NETWORK_CONTACT_DETAILS__PHONE),
  }
}

interface IProps {
  school: School
  align?: 'left' | 'center'
}

const Text = BaseText.withComponent('div')

export function NetworkContactDetails(props: IProps) {
  const { align, school } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const whitelabelContext = useWhitelabel()
  const { title, body, phone } = getCopy(whitelabelContext, school)

  if (!(title && body && phone)) {
    return null
  }

  return (
    <Section>
      <Container align={align}>
        <Title>{t(title)}</Title>
        <Text>
          {t(body)} <PhoneLink href={`tel:${t(phone)}`}>{t(phone)}</PhoneLink>.
        </Text>
      </Container>
    </Section>
  )
}
